import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import { connect } from 'react-redux';

import React, { PureComponent } from 'react';
import { Module } from '@cuemath/comps';

import { getAll as getBlockContents } from 'actions/block-contents';
import BlockContent from './view';

class BlockContentContainer extends PureComponent {
  static propTypes = {
    blockVersionId: PropTypes.string.isRequired,
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    blockContent: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    actions: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.refreshData();
  }

  refreshData() {
    const { actions, blockVersionId } = this.props;
    actions.getBlockContents({ block_version_id: blockVersionId });
  }

  render() {
    const { blockContent, match } = this.props;

    return (
      <Module
        match={match}
        module={BlockContent}
        resource={blockContent || {}}
        blockContent={blockContent ? blockContent.data : {}}
      />
    );
  }
}

export default connect(
  ({ blockContent }, { blockVersionId }) => ({
    blockContent: store.getAll(blockContent, { block_version_id: blockVersionId }),
  }),
  dispatch => ({
    actions: bindActionCreators({ getBlockContents }, dispatch),
  }),
)(BlockContentContainer);
